<template>

<portal to="top" :order="order || 1">

<div class="advanced" :key="forceKey || randomKey" v-bind:class="{'is-active': active, 'has-advanced': hasAdvanced, 'is-wide': false}">

	<core-filter-advanced-section class="advanced-head" :class="{'has-scrolled': scrollY > 0 && !hasAdvanced}" v-propagation>
		
		<div class="head-title">{{ (title) ? title : 'Filters' }}</div>

		<div class="head-close" v-tooltip="'Close'" v-on:click.stop="onClose"><i class="fa fa-remove"></i></div>

	</core-filter-advanced-section>

	<core-filter-advanced-switch 
		:mode="mode"
		:has-advanced="hasAdvanced" 
		:has-source="hasSource" 
		:filter="filter"
		v-on:change="onModeChange"
		v-if="hasAdvanced || hasSource" 
	/>

	<div class="advanced-body">

		<core-simplebar class="advanced-content-wrapper" :trackScroll="true" v-on:scroll="onScroll" :class="{'is-sorting': hideScroll}">

			<div class="advanced-content" v-show="isModeStandard" v-propagation>

				<slot name="inputs"></slot>

			</div>

			<core-filter-advanced-builder :filterName="filter" class="advanced-content" v-if="isModeAdvanced" />

			<div class="advanced-content" v-if="isModeSource">

				<core-filter-advanced-inputs>

					<core-filter-advanced-title>Sources</core-filter-advanced-title>

					<app-filter-template-common-source :filter="filter" />

				</core-filter-advanced-inputs>

			</div>

		</core-simplebar>

	</div>

	<core-filter-advanced-section class="advanced-foot" v-propagation>
		
		<slot name="buttons"></slot>

		<core-button v-if="totalFilterCount && filter && hasReset" v-on:click.native="$emit('reset')" theme="blue" fluid="yes">Reset filter</core-button>

	</core-filter-advanced-section>

</div>

</portal>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: ['active', 'filter', 'order', 'forceKey', 'title', 'hasAdvanced', 'hasSource', 'hasClose', 'hasReset'],

	data: function() {

		return {
			hideScroll: false,
			scrollY: 0,
			mode: 1,
			randomKey: ''
		}

	},

	computed: {

		totalFilterCount: function() {

			return (this.filter) ? this.$store.getters['filter/' + this.filter + '/active/count'] : true

		},

		isModeStandard: function() {

			return this.mode === 1

		},

		isModeAdvanced: function() {

			return this.mode === 2

		},

		isModeSource: function() {

			return this.mode === 3

		},

		advancedCount: function() {

			return this.$store.getters['filter/' + this.filter + '/advanced/count']

		},

		normalCount: function() {

			return this.$store.getters['filter/' + this.filter + '/active/count'] - this.advancedCount

		},

		hasButtons: function() {

			if (this.hasClose || (this.hasReset && this.window.is.mobile)) return true

			if (this.$slots.buttons !== undefined) {

				var exists = false

				this.$_.each(this.$slots.buttons, function(button) {

					if (button.tag) exists = true

				})

				if (exists) return true

			}

			return false

		}

	},

	watch: {

		active: function(n) {

			if (n) this.$pubsub.$emit('panel.opened')
			if (!n) this.$pubsub.$emit('panel.closed')

			if (n) {

				if(this.advancedCount && !this.normalCount) this.mode = 2

			}

			if (this.window.is.mobile) {

				if (n) this.$pubsub.$emit('open.dropdown')
				if (!n) this.$pubsub.$emit('close.dropdown')

			}

		}

	},

	created: function() {

		if (this.hasSource) this.mode = 3
		this.randomKey = this.$util.key()

		this.$pubsub.$on('open.inline.sort', this.onOpenInlineSort.bind(this))
		this.$pubsub.$on('close.inline.sort', this.onCloseInlineSort.bind(this))

	},

	beforeDestroy: function() {

		this.$pubsub.$off('open.inline.sort', this.onOpenInlineSort.bind(this))
		this.$pubsub.$off('close.inline.sort', this.onCloseInlineSort.bind(this))

	},

	methods: {

		onScroll: function(e) {

			this.scrollY = e.y

		},

		onModeChange: function(value) {

			this.mode = value

		},

		onOpenInlineSort: function() {

			this.hideScroll = true

		},

		onCloseInlineSort: function() {

			this.hideScroll = false

		},

		onClose: function() {

			this.$emit('clickoutside')

		}

	}

}

</script>

<style scoped>

.advanced-head {
	z-index: 2;
	flex-shrink: 0;
	height: 64px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 20px;
    background-color: #19455c;
}

.is-mobile .advanced-head.has-scrolled {
	box-shadow: rgba(9, 30, 66, 0.15) 0px 8px 8px -2px;
	z-index: 20;
}

.is-smaller .advanced-head {
	height: 64px;
}

.is-mobile .advanced-head {
	height: 48px;
	padding: 0px 10px;
	background-color: #fff;
}

.advanced:not(.has-advanced) .advanced-head:after {
    content: '';
    display: block;
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 16px 16px 0 16px;
    border-color: #19455c transparent transparent transparent;
    transform: rotate(0deg);
    position: absolute;
    left: 17px;
    bottom: -10px;
}

.is-mobile .advanced:not(.has-advanced) .advanced-head:after {
    display: none;
}

.head-title {
	text-align: left;
	font-size: 20px;
	color: #fff;
	font-weight: 500;
	line-height: 24px;
	display: flex;
	flex-direction: row;
	align-items: center;
}

.is-mobile .head-title {
	color: #343434;
    font-family: 'Barlow', sans-serif;
    letter-spacing: 1px;
    font-weight: 700;
    font-size: 16px;
}

.head-close {
	position: absolute;
	right: 20px;
	top: 12px;
	height: 40px;
	width: 40px;
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.25);
	color: #fff;
	line-height: 40px;
	font-size: 20px;
	text-align: center;
	cursor: pointer;
	z-index: 3;
}

.is-smaller .head-close {
	top: 12px;
}

.is-mobile .head-close {
	top: 8px;
	width: 32px;
	height: 32px;
	right: 10px;
	line-height: 32px;
	font-size: 14px;
	border-radius: 50%;
	background-color: #f7f7f7;
	color: #333;
	box-shadow: rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
}

.is-desktop .head-close:hover,
.is-smaller .head-close:hover {
	background-color: rgba(0, 0, 0, 0.5);
}

.advanced {
	position: fixed;
	left: -384px;
	top: 0px;
	width: 384px;
	bottom: 0px;
	z-index: 400000003;
	transition: left 100ms linear;
	display: flex;
	flex-direction: column;
}

.advanced.has-advanced {
	width: 384px;
}

.advanced.is-wide {
	left: -384px;
	width: 384px;
}

.is-mobile .advanced {
	transition: none;
	top: 0px;
	bottom: 0px;
	right: 0px;
	left: 0px;
	width: auto;
	height: auto;
	display: none;
	overflow: hidden;
}

.advanced.is-active {
	left: 0px;
}

.is-mobile .advanced.is-active {
	display: flex;
	left: 0px;
}

.advanced-body {
	width: 384px;
	display: flex;
	flex-grow: 1;
	z-index: 2;
	overflow: hidden;
}

@media only screen and (max-width: 767px) {

	.advanced-body {
		width: 100%;
	}

}

.advanced-content-wrapper {
	width: 100%;
}

.advanced-content-wrapper.is-sorting >>> .simplebar-wrapper {
	z-index: 2;
}

.advanced-content {
	width: 384px;
	background-color: #2b5870;
	display: flex;
	flex-grow: 1;
	padding: 10px 0px;
	flex-direction: column;
}

.is-mobile .advanced-content {
	width: 100%;
	padding: 0px 0px;
	background-color: #fff;
}

.advanced.has-advanced .advanced-content {
	padding-top: 10px;
	padding-bottom: 10px;
	margin-left: 0px;
}

.advanced-head {
	width: 384px;
	flex-shrink: 0;
	z-index: 1;
}

.advanced.has-advanced .advanced-head {
	margin-left: 0px;
}

.advanced-foot {
	width: 384px;
	flex-shrink: 0;
	display: grid;
	z-index: 1;
	padding: 10px 15px!important;
    background-color: #19455c;
	grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
	grid-gap: 10px;
}

.is-mobile .advanced-foot {
	padding: 10px 10px!important;
	width: 100%;
	margin-left: 0px;
	background-color: #fff;
	border-top: 1px solid #eee;
}

.advanced-foot:empty {
	display: none;
}

.advanced-foot >>> .button {
	margin-top: 0px;
}

@media only screen and (max-width: 767px) {

	.advanced-content {
		margin-left: 0px;
		width: 100%;
	}
	
	.advanced-head {
		margin-left: 0px;
		width: 100%;
		padding: 8px 10px 8px 10px!important;
	}

}

</style>